#import "src/fragments/tagFragments.graphql"
#import "src/queries/fragments/personFragment.graphql"
#import "src/queries/fragments/personManagerFragment.graphql"
#import "src/allocation/graphql/allocation.graphql"

fragment PersonAllocationsFragment on Person {
  aggregateId
  allocations {
    fte
    targetGroupId
  }
}

fragment PersonSupplyGroupFragment on Person {
  supplyGroup {
    id
    name
    type
  }
}

query peopleSearch(
  $teamIds: [String]
  $directTeamIds: [String]
  $includeIndirectTeamMembers: Boolean
  $size: Int
  $specifiedDate: DateTime
  $withSupplyGroup: Boolean = false
) {
  result: searchPeople(
    size: $size
    filter: {
      teams: {
        teams: $teamIds
        directTeams: $directTeamIds
        includeIndirectTeamMembers: $includeIndirectTeamMembers
        intersectingTeamMembers: true
      }
    }
    specifiedDate: $specifiedDate
  ) {
    totalCount
    searchAfterId
    people {
      aggregateId
      bands
      employeeId
      firstName
      surname
      preferredName
      jobTitle
      gender
      avatar
      fte
      isPlaceholder
      disabled
      allocations {
        fte
        targetGroupId
        targetGroup {
          id
          name
          type
          hierarchyIds
          parentIds
        }
      }
      ...PersonSupplyGroupFragment @include(if: $withSupplyGroup)
    }
  }
}

query getPeopleByIds(
  $ids: [String!]
  $includeDepartedPeople: Boolean = false
  $includeRemovedTags: Boolean = false
  $withSupplyGroup: Boolean = false
) {
  people: getPeopleByIds(
    ids: $ids
    includeDepartedPeople: $includeDepartedPeople
  ) {
    aggregateId: employeeId
    employeeId
    disabled
    tags: appliedTags(includeRemovedTags: $includeRemovedTags) {
      ...EntityTagMinimalFragment
    }
    allocations {
      fte
      targetGroupId
    }
    ...PersonSupplyGroupFragment @include(if: $withSupplyGroup)
  }
}

query getPitPeopleByIds(
  $ids: [String!]
  $specifiedDate: DateTime
  $withSupplyGroup: Boolean = false
) {
  people: getPeopleByIds(ids: $ids, specifiedDate: $specifiedDate) {
    ...PersonAllocationsFragment
    ...PersonSupplyGroupFragment @include(if: $withSupplyGroup)
  }
}

query getMembersById(
  $ids: [String!]
  $includeRemovedTags: Boolean = false
  $includeTags: Boolean = false
) {
  people: getPeopleByIds(ids: $ids, includeDepartedPeople: true) {
    aggregateId
    bands
    employeeId
    firstName
    surname
    preferredName
    jobTitle
    gender
    avatar
    fte
    isPlaceholder
    disabled
    allocations {
      fte
      targetGroupId
      targetGroup {
        id
        name
        type
        hierarchyIds
        parentIds
      }
    }
    tags: appliedTags(includeRemovedTags: $includeRemovedTags)
      @include(if: $includeTags) {
      ...EntityTagMinimalFragment
    }
  }
}

mutation updateTagsOnEntities($input: UpdateTagsOnEntitiesInput) {
  result: updateTagsOnEntities(input: $input)
}

mutation addNewVacantRole($input: NewPeopleInput!) {
  result: addPeople(input: $input) {
    aggregateId
    preferredName
    fte
  }
}

mutation addPosition($input: AddPositionInput!) {
  result: addPosition(input: $input) {
    id
    person {
      aggregateId
      preferredName
      fte
      jobTitle
      city
      country
      state
      bands
      isVacancy
      managedBy {
        aggregateId
        preferredName
      }
    }
    establishedFte
    startDate
    endDate
  }
}

mutation recreatePosition($input: RecreatePositionInput!) {
  result: recreatePosition(input: $input) {
    previousPosition {
      id
    }
    position {
      id
    }
    movedFillPersonIds
  }
}

mutation updatePosition($input: UpdatePositionInput!) {
  result: updatePosition(input: $input) {
    id
    person {
      aggregateId
      preferredName
      fte
      jobTitle
      city
      country
      state
      bands
      isVacancy
      managedBy {
        aggregateId
        preferredName
      }
    }
    establishedFte
    startDate
    endDate
  }
}

mutation removePlaceholderPerson($personId: ID!) {
  result: removePlaceholderPerson(personId: $personId) {
    aggregateId
    disabled
  }
}
